// Â© 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import type asset from '../../SourceArt/Apron/mesh.json'
let data:typeof asset|undefined
export async function prepareApronAssembly():Promise<void>{data??=(await import('../../SourceArt/Apron/mesh.json')).default}
export function fittedApron(size:ApronSize):ApronPart[]|undefined{return data===undefined?undefined:fitApron(data,size)}
export interface ApronPart {name:string;role:string;positions:number[];normals:number[];uvs:number[];triangles:number[]}
export interface ApronSize {width:number;depth:number;height:number;cardWidth:number;cardDepth:number}
// Anchor translations preserve the sheet gauge, bevel radii and screw diameter while spans change.
function fitApron(source:typeof asset,size:ApronSize):ApronPart[]{
 const {width,depth,height,cardWidth,cardDepth}=size,r=source.reference,groups=new Map<string,ApronPart>()
 if(![width,depth,height,cardWidth,cardDepth].every(v=>Number.isFinite(v)&&v>0))throw Error('Invalid apron dimensions')
 for(const part of source.parts){
  const frame=part.frame,placements=frame==='deck'?[[0,0]]:frame==='bed'?[[-r.cardCentre,0],[r.cardCentre,0]]:[-r.cardCentre,r.cardCentre].flatMap(x=>[-cardDepth/2-(r.railCentreOffset??r.railHalfWidth),cardDepth/2+(r.railCentreOffset??r.railHalfWidth)].map(y=>[x,y]))
  let group=groups.get(part.role)
  if(group===undefined){group={name:'instructions.apron.authored.'+part.role,role:part.role,positions:[],normals:[],uvs:[],triangles:[]};groups.set(part.role,group)}
  for(const place of placements){
   const base=group.positions.length/3
   for(let i=0;i<part.positions.length;i+=3){
    let x=part.positions[i]!,y=part.positions[i+1]!,z=part.positions[i+2]!
    if(frame==='deck'){x+=Math.sign(x)*(width-r.width)/2;y+=Math.sign(y)*(depth-r.depth)/2;if(z>r.height/2)z+=height-r.height}
    else{
     x+=(frame==='screw'?part.anchor[0]!:Math.sign(x))*(cardWidth-r.cardWidth)/2;z+=height-r.height
     if(frame==='bed')y+=Math.sign(y)*(cardDepth-r.cardDepth)/2
    }
    group.positions.push(x+place[0]!,y+place[1]!,z)
   }
   group.normals.push(...part.normals);group.uvs.push(...part.uvs);group.triangles.push(...part.triangles.map(i=>i+base))
  }
 }
 return [...groups.values()]
}
